import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmailDashboardRoutingModule } from './email-dashboard-routing.module';
import {DropdownModule} from 'primeng/dropdown';
import {CoreModule} from '../../core/core.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {TableModule} from 'primeng/table';
import {CalendarModule, CheckboxModule, TreeTableModule} from 'primeng/primeng';
import {TranslateModule} from '@ngx-translate/core';
import {EmailDashboardComponent} from './email-dashboard.component';
import {NgSelectModule} from '@ng-select/ng-select';
import { SendEmailModalComponent } from './sendEmailModal/send-email-modal.component';

@NgModule({
  imports: [
    CommonModule,
    EmailDashboardRoutingModule,
    DropdownModule,
    CoreModule,
    NgbModule,
    FormsModule,
    AutoCompleteModule,
    TableModule,
    TreeTableModule,
    TranslateModule,
    CalendarModule,
    CheckboxModule,
    NgSelectModule,
  ],
  declarations: [
    EmailDashboardComponent,
    SendEmailModalComponent
  ],
  entryComponents:[SendEmailModalComponent],
  exports: [
    EmailDashboardComponent
  ]
})
export class EmailDashboardModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/email-dashboard.module.ts